import { SelfPatient } from "./types";

// Address is compared and selected as ONE field (matching Patient Merge and
// the Figma "ADDRESS" row) so the merged record can never end up with a city
// from one customer and a postal code from another. The backend still takes
// the four components separately — whichever column wins this field has all
// four forwarded together at submit time.
const formatSelfPatientAddress = (
  selfPatient: SelfPatient | null | undefined,
): string | null => {
  if (!selfPatient) return null;
  const parts = [
    selfPatient.city,
    selfPatient.state,
    selfPatient.postal_code,
    selfPatient.country,
  ].filter(Boolean);
  return parts.length > 0 ? parts.join(", ") : null;
};

export default formatSelfPatientAddress;
